import { API_MAP } from "../../apiConfig";
import { sessionStore } from "./sessionStore";
import { callProjectAPI } from "../projectApiService";

const config = API_MAP.APPLY_WFH;

const normalizeValue = (field, value) => {
  const v = value.toLowerCase().trim();

  if (field === "IsHalfDay") {
    if (v === "yes") return true;
    if (v === "no") return false;
    throw new Error('Please answer "yes" or "no".');
  }

  if (field === "HalfPreference") {
    if (v.includes("first")) return "First Half";
    if (v.includes("second")) return "Second Half";
    throw new Error('Please say "first half" or "second half".');
  }

  return value;
};

export const handleApplyWFH = async (userMessage) => {
  // Initialize session
  if (!sessionStore.activeIntent) {
    const user = JSON.parse(localStorage.getItem("User") || "{}");

    sessionStore.activeIntent = "APPLY_WFH";
    sessionStore.payload = {
      EmpId: user?.EmpId,
      OrgId: user?.OrgId,
      BranchId: user?.BranchId || 0,
      LoggedInEmpId: user?.EmpId,
      WFHStatusId: config.WFHStatusId  // 103 = applied/pending
    };
    sessionStore.lastAskedField = null;
  }

  // Save the answer to the last asked field
  if (sessionStore.lastAskedField && userMessage !== undefined) {
    const field = sessionStore.lastAskedField;
    try {
      const value = normalizeValue(field, userMessage);
      sessionStore.payload[field] = value;

      // If not half day, skip HalfPreference
      if (field === "IsHalfDay" && value === false) {
        sessionStore.payload.HalfPreference = "";
      }
    } catch (err) {
      return { message: `⚠️ ${err.message}\n\n👉 ${config.questions[field]}` };
    }
  }

  // Find next unanswered required field
  const nextField = config.requiredFields.find((field) => {
    if (field === "HalfPreference" && sessionStore.payload.IsHalfDay === false) {
      return false;
    }
    return sessionStore.payload[field] === undefined;
  });

  if (nextField) {
    sessionStore.lastAskedField = nextField;
    return { message: config.questions[nextField] };
  }

  // All fields collected — submit
  try {
    await callProjectAPI("APPLY_WFH", sessionStore.payload);
    resetSession();
    return { message: "Your WFH request has been submitted successfully!" };
  } catch (err) {
    resetSession();
    return { message: `⚠️ ${err.message}` };
  }
};

const resetSession = () => {
  sessionStore.activeIntent = null;
  sessionStore.payload = {};
  sessionStore.lastAskedField = null;
};
